import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RequisitionTestDataService } from '../../data-services/requisitionTest.service';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-unreject-dialog',
  templateUrl: './unrejectReason.dialog.html',
  providers: [MessageService],
  imports: [Dialog, FormsModule, CommonModule]
})
export class UnRejectDialogComponent implements OnInit {

  constructor(
    private requisitionService: RequisitionDataService,
    private requisitionTestService: RequisitionTestDataService,
    private messageService: MessageService) {
  }

  loading: boolean = false;
  selectedRejectionType: any = [];
  unrejectionDescription: string = "";
  rejectionLevel: string = 'req';



  ngOnInit() {
  }

  @Input() public accession: string = null;
  @Input() public requisitionId: number = null;
  @Input() public requisitionRejectionId: number = null;
  @Input() public requisitionTestRejectionId: number = null;
  @Input() public showUnrejectDialog: boolean;

  @Output() public accessionChange = new EventEmitter<string>();
  @Output() public requisitionIdChange = new EventEmitter<number>();
  @Output() public requisitionTestRejectionIdChange = new EventEmitter<number>();
  @Output() public showUnrejectDialogChange = new EventEmitter<boolean>();
  @Output() public onClose = new EventEmitter<boolean>();

  unReject()
  {
    this.loading = true;
    
    if (!this.requisitionTestRejectionId) { // we are rejecting a Requisition
      var currentRejection =  { id: this.requisitionRejectionId, RequisitionId: this.requisitionId, UnrejectDescription:this.unrejectionDescription};

      this.requisitionService.unrejectRequisition(currentRejection).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'UnReject ', detail: `Successful` });
        this.unrejectionDescription = null;

        this.close(true);
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'UnReject ', detail: 'Failed: ' + err.error });
        this.unrejectionDescription = null;
        this.close(false);

      });
    } else { //we are unrejecting a RequisitionTestRejection
    
      this.requisitionTestService.unreject(this.accession, null, this.requisitionTestRejectionId, this.unrejectionDescription).subscribe((data: boolean) => {
        this.messageService.add({ severity: 'success', summary: 'UnReject Test', detail: `Successful` });
        this.close(true);
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'UnReject Test', detail: 'Failed: ' + err.error });
        this.close(false);
      });
    }
  }


  public close(value) {
    console.log(`Closing ${value}`);
    this.loading = false;
    this.accession = null;
    this.requisitionId = null;
    this.requisitionTestRejectionId = null;
    this.showUnrejectDialog = false;

    this.accessionChange.emit(this.accession);
    this.requisitionIdChange.emit(this.requisitionId);
    this.requisitionTestRejectionIdChange.emit(this.requisitionTestRejectionId);
    this.showUnrejectDialogChange.emit(this.showUnrejectDialog);
    this.onClose.emit(value);
  }
  
 
}
